import PrestaID from "../../components/PrestaID/PrestaID"

export default function ServiceID() {
    return (
        <main>
            <PrestaID />
        </main>
    )
}